interface TestResultProps {
  result: string | null;
  isSuccess: boolean;
}

export const TestResult = ({ result, isSuccess }: TestResultProps) => {
  if (!result) return null;

  return (
    <div
      className={`p-4 rounded-md ${
        isSuccess
          ? "bg-green-100 text-green-800"
          : "bg-red-100 text-red-800"
      }`}
    >
      {result}
    </div>
  );
};